<template>
  <div>
    <table-card
      ref="datatable"
      module="Command"
      :headers="headers"
      :actions="actions"
    >
      <template v-slot:action>
        <vs-button color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Add New Data</vs-button>
      </template>
    </table-card>    

    <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
      <template>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input label="Name" class="w-full" v-model="input.name" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input label="Command" class="w-full" v-model="input.check" />
          </div>
        </div>
        <!-- SET -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/2 w-full">
            <vs-checkbox v-model="input.set">Set</vs-checkbox>
          </div>
        </div>
        <div class="pt-5" v-show="input.set === true" style="border: 1px solid #eee; padding: 5px 10px; border-radius: 6px;">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input label="Command" class="w-full" v-model="input.setCommand" />
            </div>
            <div class="vx-col sm:w-1/4 w-full" style="padding-top: 2px;">
              <vs-button class="mr-3 mt-5" color="success" style="width: 100%" @click="addInput('setInput')">+ Input</vs-button>
            </div>
          </div>

          <div v-for="(i, index) in setInputCount" :key="i" class="command-input-area">
            <button class="close" @click="deleteInput('setInput', index)">x</button>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input :label="`Slug ${i}`" v-model="input.setInput[index].slug" class="w-full" />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input :label="`Label ${i}`" v-model="input.setInput[index].label" class="w-full" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input :label="`Description ${i}`" v-model="input.setInput[index].description" class="w-full" />
              </div>
            </div>
          </div>
        </div>
        <!-- SET -->

        <!-- UNSET -->
        <div class="vx-row mb-3 mt-6">
          <div class="vx-col sm:w-2/2 w-full">
            <vs-checkbox v-model="input.unset">Unset</vs-checkbox>
          </div>
        </div>
        <div class="pt-5" v-show="input.unset === true" style="border: 1px solid #eee; padding: 5px 10px; border-radius: 6px;">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-3/4 w-full">
              <vs-input label="Command" class="w-full" v-model="input.unsetCommand" />
            </div>
            <div class="vx-col sm:w-1/4 w-full" style="padding-top: 2px;">
              <vs-button class="mr-3 mt-5" color="success" style="width: 100%" @click="addInput('unsetInput')">+ Input</vs-button>
            </div>
          </div>

          <div v-for="(i, index) in unsetInputCount" :key="i" class="command-input-area">
            <button class="close" @click="deleteInput('unsetInput', index)">x</button>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input :label="`Slug ${i}`" v-model="input.unsetInput[index].slug" class="w-full" />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input :label="`Label ${i}`" v-model="input.unsetInput[index].label" class="w-full" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input :label="`Description ${i}`" v-model="input.unsetInput[index].description" class="w-full" />
              </div>
            </div>
          </div>
        </div>
        <!-- UNSET -->
        <div class="vx-row pt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button :disabled="isSubmit" id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
            <vs-button :disabled="isSubmit" v-show="action === 'store'" color="warning" type="border" class="mr-3 mb-2" @click="reset">Reset</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>
  </div>

</template>

<script>
import vSelect from 'vue-select'
import TableCard from '@/components/TableCard'

export default {
  components: {
    vSelect,
    TableCard,
  },

  data () {
    return {
      showPopup: false,
      popupTitle: '',
      action: '',
      isSubmit: false,
      setInputCount: 0,
      unsetInputCount: 0,
      input: {
        id: null,
        name: null,
        set: null,
        unset: null,
        setCommand: null,
        setInput: [],
        unsetCommand: null,
        unsetInput: [],
        check: null
      },
    }
  },

  computed: {
    headers() {
      return [
        [
          { label: 'Name', value: 'name', rowspan: 2 },
          { label: 'Type', colspan: 3, class: 'text-center' },
        ],
        [
          { label: 'Check', value: 'check' },
          { label: 'Set', value: 'set', formatter: this.commandFormat },
          { label: 'Unset', value: 'unset', formatter: this.commandFormat },
        ],
      ]
    },
    actions() {
      return [
        { name: 'Edit', action: this.edit, icon: 'icon-edit', color: 'success' },
        { name: 'Delete', action: this.del, icon: 'icon-trash', color: 'danger' },
      ]
    },
  },
  watch: {},
  created () {},
  mounted () {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },
    
    reset() {
      Object.keys(this.input).map(item => {
        if(item === 'setInput' || item === 'unsetInput') this.input[item] = []
        else this.input[item] = null
      })

      this.setInputCount = 0
      this.unsetInputCount = 0
    },

    addInput(param) {
      this[`${param}Count`]++
      this.input[param].push({
        slug: '',
        label: '',
        description: ''
      })
    },

    deleteInput(param, index) {
      this[`${param}Count`]--
      this.input[param].splice(index, 1)
    },

    add() {
      if(this.action === 'update') this.reset()
      this.action = 'store'
      this.popupTitle = 'Add Command'
      this.showPopup = true
    },

    async edit(id) {
      this.input.id = id
      this.action = 'update'
      this.popupTitle = 'Edit Command'

      await this.$store.dispatch('Command/detail', id).then(data => {
        this.input.name = data.name
        this.input.check = data.check ? data.check : ''

        /* SET */
        this.input.set = data.set ? true : false
        const setData = JSON.parse(data.set)
        this.input.setCommand = data.set ? setData.command : ''
        this.input.setInput = data.set ? setData.input: []
        this.setInputCount = data.set ? setData.input.length : 0

        /* UNSET */
        this.input.unset = data.unset ? true : false
        const unsetData = JSON.parse(data.unset)
        this.input.unsetCommand = data.unset ? unsetData.command : ''
        this.input.unsetInput = data.unset ? unsetData.input : []
        this.unsetInputCount = data.unset ? unsetData.input.length : 0
      })
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')

      const set = {
        command: this.input.setCommand,
        input: this.input.setInput
      }

      const unset = {
        command: this.input.unsetCommand,
        input: this.input.unsetInput
      }

      const {status, message} = await this.$store.dispatch(`Command/${this.action}`, {
        id: this.input.id,
        name: this.input.name,
        check: this.input.check,
        set: this.input.set ? JSON.stringify(set) : '',
        unset: this.input.unset ? JSON.stringify(unset) : '',
      })

      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if(status) {
        this.showNotify(message)
        this.initTable()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Command`,
        text: 'Are you sure want to Delete this Command ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const {status, message} = await this.$store.dispatch('Command/delete', this.input.id)
      if(status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },
    
    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },

    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    },

    commandFormat(data) {
      return data ? JSON.parse(data).command : '-'
    },
  },
}

</script>
